module.exports = __webpack_public_path__ + "static/media/model_s.acf0f87f.jpg";